import request from '@/utils/request'

// 获得当前用户的未读站内信数量
export const unreadCount = ()=>{
  return request({
    url: '/admin-api/client/pc/notify-message/get-unread-count',
    method: 'get'
  })
}

// 获取当前用户的最新站内信列表，默认 10 条
export const newMessageList = (params)=>{
  return request({
    url: '/admin-api/client/pc/notify-message/get-unread-list',
    method: 'get',
    params: params
  })
}

// 获得我的站内信分页
export const messageList = (params)=>{
  return request({
    url: '/admin-api/client/pc/notify-message/my-page',
    method: 'get',
    params: params
  })
}

// 标记所有站内信为已读
export const allRead = ()=>{
  return request({
    url: '/admin-api/client/pc/notify-message/update-all-read',
    method: 'put',
  })
}

// 标记站内信为已读
export const read = ()=>{
  return request({
    url: '/admin-api/client/pc/notify-message/update-read',
    method: 'put'
  })
}




